import React from "react";

const Badge = ({
  children,
  variant = "default",
  size = "md",
  className = "",
}) => {
  const baseClasses = "inline-flex font-medium border-none";

  const sizeClasses = {
    sm: "px-2 py-1 text-xs",
    md: "px-2.5 py-1.5 text-sm",
    lg: "px-3 py-2 text-base",
  };

  const variantClasses = {
    default: "bg-gray-100 text-gray-800",
    primary: "bg-blue-100 text-blue-800",
    success: "bg-green-100 text-green-800",
    warning: "bg-yellow-100 text-yellow-800",
    error: "bg-red-100 text-red-800",
    sale: "bg-red-500 text-white",
    new: "bg-blue-500 text-white",
    featured: "bg-purple-100 text-purple-800",
  };

  // Reduce horizontal padding for all sizes
  const sharpSizeClasses = {
    sm: "px-1.5 py-0.5 text-xs",
    md: "px-2 py-1 text-sm",
    lg: "px-2.5 py-1.5 text-base",
  };
  const classes = `${baseClasses} ${sharpSizeClasses[size]} ${variantClasses[variant]} text-left ${className}`;

  return <span className={classes}>{children}</span>;
};

export default Badge;
